import {
  CURRENT_QUESTIONS,
  MUTATION_SUBMIT_ANSWER,
  MUTATION_SUBMIT_SURVEY_USERS,
} from './../../graphql/queries/weekly-question/weeklyQuestion';
import requestHandler from '../requestHandler';
import {
  Exact,
  AnswerInput,
  SurveyUserInput,
  CurrentQuestionsQuery,
  CurrentQuestionsQueryVariables,
  SubmitAnswerMutation,
  SubmitAnswerMutationVariables,
  SubmitSurveyUserMutation,
  SubmitSurveyUserMutationVariables,
} from '@/graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';

export const requestDailyQuestions = async () => {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<CurrentQuestionsQuery, CurrentQuestionsQueryVariables>({
      query: CURRENT_QUESTIONS,
    }),
  );

  return { data };
};

export const submitAnswer = async (
  data: Exact<{
    data: AnswerInput;
  }>,
) => {
  const apolloClient = initializeApollo();

  const { data: submitAnswer } = await requestHandler(
    apolloClient.mutate<SubmitAnswerMutation, SubmitAnswerMutationVariables>({
      mutation: MUTATION_SUBMIT_ANSWER,
      variables: data,
    }),
  );

  return { data: submitAnswer };
};

export const submitSurveyUser = async (
  data: Exact<{
    data: SurveyUserInput;
  }>,
) => {
  const apolloClient = initializeApollo();

  const { data: submitSurveyUser } = await requestHandler(
    apolloClient.mutate<SubmitSurveyUserMutation, SubmitSurveyUserMutationVariables>({
      mutation: MUTATION_SUBMIT_SURVEY_USERS,
      variables: data,
    }),
  );

  return { data: submitSurveyUser };
};
